import React from 'react'

import {
  AlignItems,
  Body2,
  BorderStyle,
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  FlexDirection,
  Heading6,
  Join,
  Space,
} from '@gousto-internal/citrus-react'

import { Equipment } from '@library/menu-service/queries/menuApiMenuRecipe/types'

type EquipmentMissingProps = {
  equipment: Equipment[]
  onClick: () => void
}

export const EquipmentBanner = ({ equipment, onClick }: EquipmentMissingProps) => {
  const equipmentMissing = equipment && equipment.some((item) => item.is_missing)
  const bgColor = equipmentMissing ? Color.Error_50 : Color.Success_50
  const borderColor = equipmentMissing ? Color.Error_200 : Color.Success_200
  const headingText = equipmentMissing
    ? "You're missing some equipment to cook this"
    : 'You own all the equipment to cook this'

  return (
    <Box
      data-testid="equipment-banner"
      bg={bgColor}
      borderColor={borderColor}
      borderRadius={1.5}
      borderWidth={0.5}
      borderStyle={BorderStyle.Solid}
    >
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.FlexStart}
        paddingH={4}
        paddingV={4}
      >
        <Join with={<Space size={3} />}>
          <Heading6 data-testid="equipment-banner-heading">{headingText}</Heading6>
          <Body2 color={Color.ColdGrey_900}>
            Anything changed? Let us know by updating your preferences.
          </Body2>
          <Button
            data-testid="equipment-banner-button"
            style={{
              backgroundColor: Color.Transparent,
            }}
            colorVariant={ButtonColorVariant.Secondary}
            width="100%"
            onClick={onClick}
          >
            Update preferences
          </Button>
        </Join>
      </Box>
    </Box>
  )
}
